import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { DispatchRefTrackingBus } from '../../shared/models/DispatchRefTrackingBus';
import { SaveMode } from '../../shared/enums/SaveMode';
import { Collision } from '@progress/kendo-angular-popup';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'ref-tracking',
    templateUrl: './ref-tracking.component.html',
    styleUrls: ['./ref-tracking.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RefTrackingComponent extends BaseGridEditLineComponent<DispatchRefTrackingBus, null, DispatchesService>  {
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "DispatchRefTrackingBus";
        this.appCode = "RefTracking";
        this.appName = "Ref Tracking";
        this.callSaveIndividualInsteadOfSave = true;
        this.disableCpSearchDialog();
    }

    override createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchRefTrackingId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'refTrackNbr': new UntypedFormControl(),
            'refTrackDate': new UntypedFormControl(),
            'isComplete': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'person': new UntypedFormControl()
        });

    }
    override setForm() {
        this.editForm.patchValue({
            dispatchRefTrackingId: this.selectedData.dispatchRefTrackingId,
            dispatchId: this.selectedData.dispatchId,
            refTrackNbr: this.selectedData.refTrackNbr,
            refTrackDate: this.selectedData.refTrackDate,
            isComplete: this.selectedData.isComplete,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            person: this.selectedData.person
        });
    }
    refTrackComplete: boolean = false;
    refTrackNbr: string = "";
    lastRefTrack: DispatchRefTrackingBus = new DispatchRefTrackingBus();
    override processGridData() {
        this.refTrackComplete = false;
        this.refTrackNbr = "";
        if (this.hasGridData) {
            let dataObj: DispatchRefTrackingBus = null;
            this.refTrackComplete = this.gridData.some(s => s.isComplete == true);
            if (this.refTrackComplete) {
                this.lastRefTrack = this.gridData.find(s => s.isComplete == true);
            }
            else {
                for (let i = 0; i < this.gridData.length; i++) {
                    if (dataObj) {
                        if (dataObj.insertDt < this.gridData[i].insertDt) {
                            dataObj = this.gridData[i];
                        }
                    }
                    else {
                        dataObj = this.gridData[i];
                    }
                }
                this.lastRefTrack = dataObj;
            }
            this.refTrackNbr = this.lastRefTrack.refTrackNbr;
        }
    }

    okHandler() {
        if (this.editForm.valid) {
            this.saveCurrent();
        }
    }

    override setFromReferenceData(data: DispatchRefTrackingBus) {
        data.person = this.personFromUserId(data.insertUserId).description;
        return data;
    }

    override getChangedObject(data: DispatchRefTrackingBus) {
        let busObj: DispatchRefTrackingBus = new DispatchRefTrackingBus(data);
        busObj = this.setFromReferenceData(busObj);
        busObj.setBeforeSave();
        return busObj;
    }
    public collision: Collision = { horizontal: "fit", vertical: "fit" };
    public show = false;

    public onToggle(): void {
        this.show = !this.show;
    }
    protected override saveIndividual(data: DispatchRefTrackingBus): Promise<BaseMessageInfo> {
        this.dataLoading = true;
        let busObj: DispatchRefTrackingBus = this.getChangedObject(data); // new v_DispatchAttachmentBus(data);
        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            this.svc_data.saveDispatchRefTracking(busObj).toPromise().then((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    busObj = new DispatchRefTrackingBus(info.primaryReturn);
                    retInfo.primaryReturn = busObj;
                    this.notify(this.appCode + " Saved Successfully!");
                }
                else {
                    retInfo.message = info.message;
                    retInfo.saveError = true;
                    this.saveError(info.primaryReturn as DispatchRefTrackingBus, info.message);
                }
                this.dataLoading = false;
                resolve(retInfo);
            });
        });

    }
    override deleteIndividual(data: DispatchRefTrackingBus) {
        if (data.hasId) {
            this.svc_data.deleteDispatchRefTracking(data.dispatchRefTrackingId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }

}
